import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const CheckInManageRoute = lazyWithRetries(() => import('.'))
const EditAudienceRoute = lazyWithRetries(() => import('./editAudience'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.checkInManage(),
    element: (
      <StandardPageLayout
        elementId="checkInManageRoute"
        title={<T _str="Check-ins" />}
        maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <CheckInManageRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.editAudience(':categoryId'),
    element: (
      <StandardPageLayout
        elementId="editAudienceRoute"
        title={<T _str="Edit audience" />}
        maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <EditAudienceRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
